import React, { Component } from 'react'

import style from "./ChatBox.module.css"
import FormControl from '@material-ui/core/FormControl'
import TextField from '@material-ui/core/TextField'
import Grid from '@material-ui/core/Grid'
import Button from '@material-ui/core/Button'
import { currentUser } from '../helpers/auth'
import Typography from '@material-ui/core/Typography'
import { db } from '../services/firebase'
export default class ChatBox extends Component {
    constructor(props) {
        super(props)

        this.state = {
            content: "",
            user: currentUser(),
            error: null
        }
    }

    handleSubmit = async (e) => {
        e.preventDefault()
        this.setState({ error: null })
        try {
            db.ref("chat").push({
                content: this.state.content,
                timestamp: Date.now(),
                uid: this.state.user.uid,
                email: this.state.user.email
            })
            this.setState({ error: null })
        } catch (e) {
            this.setState({
                error: e.message
            })
        }
    }

    render() {
        return (
            <form className={style.chatBox} onSubmit={this.handleSubmit}>
                <Grid container >
                    <Grid item xs={11} className={style.padRight}>
                        <FormControl fullWidth>
                            <TextField
                                fullWidth
                                name="content"
                                label="Message:"
                                type="text"
                                value={this.state.content}
                                onChange={(e) => this.setState({ content: e.target.value })}
                                variant="outlined"
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={1}>
                        <Button variant="contained" color="primary" type="submit" size="large" className={style.fullButton}>
                            Send
                            </Button>
                    </Grid>
                </Grid>
                <Grid container>
                    <Grid item xs={12}>
                        <Typography variant="subtitle1" color="initial">
                            Logged in as {this.state.user.email}
                        </Typography>
                    </Grid>
                </Grid>
            </form>
        )
    }
}
